import axiosInstance from '../auth/FetchInterceptor'
import { API_URL } from '../constants/environment'
import AwsS3Service from './AwsS3Service'

type GetPresignedS3UploadLinkRequest = {
  filename: string;
  abortSignal: AbortSignal;
}

type GetPresignedS3UploadLinkResponse = {
  url: string;
}

type UploadOrderFilesToS3Request = {
  files: Array<File>,
  abortSignal: AbortSignal,
}

type UploadOrderFilesToS3Response = {
  files: Promise<Array<OrderFile>>,
}

type ProposalFilesServiceType = {
  getPresignedS3UploadLink: (request: GetPresignedS3UploadLinkRequest) => Promise<GetPresignedS3UploadLinkResponse>;
  uploadOrderFilesToS3: (request: UploadOrderFilesToS3Request) => UploadOrderFilesToS3Response;
};

export type OrderFile = {
  filename: string;
  s3Url: string|null;
  data: File|null;
}

export const ProposalFilesService: ProposalFilesServiceType = {
  getPresignedS3UploadLink: (request: GetPresignedS3UploadLinkRequest) =>
    axiosInstance
      .get<never, GetPresignedS3UploadLinkResponse>(
        `${API_URL.CUSTOMER_AREA}/get-upload-url`,
        {
          params: {
            filename: request.filename,
          },
          signal: request.abortSignal,
        },
      ),
  uploadOrderFilesToS3: (request: UploadOrderFilesToS3Request) => {
    const proposalFiles = Promise.all(
      request.files
        .map(async (file): Promise<OrderFile> => {
          const fileName = file.name
          const { url: presignedS3UploadLink } = await ProposalFilesService.getPresignedS3UploadLink(
            { filename: fileName, abortSignal: request.abortSignal },
          )

          await AwsS3Service.uploadFileToS3({
            file: file,
            presignedS3UploadLink: presignedS3UploadLink,
            abortSignal: request.abortSignal,
          })

          return Promise.resolve({
            filename: fileName,
            s3Url: presignedS3UploadLink,
            data: file,
          })
        }),
    )
    return { files: proposalFiles }
  },
}